
const laoExportFilters = {

  poCreationDateRange: { // PO Creation Date
    type: "date",
    name: "po_creation_date",
    shortName: 'PO Creation Date',
    data: null
  },
  deliveryDateRange: { // Delivery Date
    type: "date",
    name: "delivery_date",
    shortName: 'Delivery Date',
    data: null
  },
  invoiceDateRange: { // Invoice Date
    type: "date",
    name: "invoice_date",
    shortName: 'Invoice Date',
    data: null
  },
  exportEtdRange: { // KC ETD
    type: "date",
    name: "export_shipment_etd_date",
    shortName: 'KC ETD',
    data: null
  },
  exportEtaRange: { // KC ETA
    type: "date",
    name: "export_shipment_eta_date",
    shortName: 'KC ETA',
    data: null
  },
  goodsReceiptDate: { // Good Received Date
    type: "date",
    name: "gr_date",
    shortName: 'GR Date',
    data: null
  },
  goodsReceiptInd: { // Good Completion
    type: "radio",
    name: "goods_completion",
    data: null
  },
  materialTypeList: { // Material Type
    type: "text",
    name: "material_type",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  importShipmentModeList: { // Shipment Mode
    type: "checkbox",
    name: "shipment_mode",
    data: [
      { name: "maritime_m", value: "M", checked: false },
      { name: "land_t", value: "T", checked: false },
      { name: "air_a", value: "A", checked: false },
    ]
  },
  vendorNumberList: { // Vendor Number
    type: "text",
    name: "vendor_number",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  finalOrderDestinationIdList: { // Customer Code
    type: "text",
    name: "customer_code",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  ftzSitesList: { // Plant FTZ Code
    type: "text",
    name: "free_trade_destination_plant",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  virtualSitesList: { // Virtual Plant Code
    type: "text",
    name: "virtual_plant_code",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  finalOrderDestinationCountryList: { // Destination Country
    type: "text",
    name: "destination_country",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  orderOriginCountryList: { // Origin Country
    type: "text",
    name: "origin_country",
    stringToArray: true,
    data: null,
    region: 'lao',
    helperText: "helperText"
  },
  deliveryCompletionInd: { // Delivery Completion
    type: "radio",
    name: "delivery_completion_ind",
    data: null
  },
  exportInternationalShipperWithSeparator: { // International Shipper
    type: "text",
    name: "international_shipper",
    stringToArray: false,
    stringValue: true, // for chips UI 
    separator: /;/,
    data: null,
    region: 'lao',
    helperText: "helperTextWithSeparator"
  }
};

export default laoExportFilters;

export const laoExportTableFilters = {

  searchStringList: { // PO numbers, Invoice Number, Load Number and Delivery Number
    type: "text",
    stringToArray: true,
    name: "search",
    data: null,
    region: 'lao'
  },
  searchSubType: { // search sub type
    type: "text",
    name: "searchSubType",
    stringToArray: false,
    data: null,
    region: 'lao',
    // helperText: "helperText"
  },
  ...laoExportFilters
}